import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {FactService} from '@webmate-web-core/shared/services/fact.service';
import {ImageUrl, ProjectId, ScreenshotId} from '@webmate-web-core/shared/types/ids';

export interface ContrastAnalysisResult {
    analysis: any;
    imageUrl: ImageUrl;
}

@Injectable({
    providedIn: 'root'
})
export class ContrastAnalysisService {
    constructor(private factService: FactService) {}

    analyzeContrast$(projectId: ProjectId, imageId: ScreenshotId | undefined, imageUrl$: Observable<ImageUrl>): Observable<ContrastAnalysisResult> {
        return imageUrl$.pipe(
            switchMap(imageUrl =>
                this.factService.analyzeContrast(projectId, imageId, imageUrl).pipe(
                    map(artifact => ({analysis: artifact.data.analysis, imageUrl}))
                )
            )
        );
    }
}
